module.exports = __webpack_public_path__ + "static/media/view-report.739db1c9.svg";